import Store from "@/store/index";

import VacationsChart from "@/pages/charts/vacations/index";
import TimesheetsList from "@/pages/charts/timesheets/list";
import TimesheetChart from "@/pages/charts/timesheets/chart";
import TimesheetChartPrint from "@/pages/charts/timesheets/print";

export default [
    {
        path: "/vacations-chart",
        name: "vacations-chart",
        component: VacationsChart,
        meta: {
            title: "График отпусков и больничных",
        },

        beforeEnter: (to, from, next) => {
            if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                Store.dispatch("filters/loadFilials", {
                    own: "viewVacations",
                    all: "viewVacationsAll",
                })
                    .then(() => {
                        next();
                    })
                    .catch(() => {
                        next({ name: "error-403" });
                    });
            } else {
                window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
            }
        },
    },

    {
        path: "/timesheets",
        name: "timesheets",
        component: TimesheetsList,
        meta: {
            title: "Табели учёта рабочего времени",
        },

        beforeEnter: (to, from, next) => {
            if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                const permissions = ["viewTimesheet", "viewTimesheetAll"];

                Store.dispatch("getUserPermissions").then(() => {
                    const userPermissions = Store.state.userPermissions;
                    const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                    if (isAvailablePage) {
                        next();
                    } else {
                        next({ name: "error-403" });
                    }
                });
            } else {
                window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
            }
        },
    },
    {
        path: "/timesheets/create",
        name: "create-timesheet",
        component: TimesheetChart,
        meta: {
            title: "Табели учёта рабочего времени",
        },

        beforeEnter: (to, from, next) => {
            if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                const permissions = ["viewTimesheet", "viewTimesheetAll"];

                Store.dispatch("getUserPermissions").then(() => {
                    const userPermissions = Store.state.userPermissions;
                    const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                    if (isAvailablePage) {
                        next();
                    } else {
                        next({ name: "error-403" });
                    }
                });
            } else {
                window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
            }
        },
    },
    {
        path: "/timesheets/:id",
        name: "edit-timesheet",
        component: TimesheetChart,
        meta: {
            title: "Табели учёта рабочего времени",
        },

        beforeEnter: (to, from, next) => {
            if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                const permissions = ["viewTimesheet", "viewTimesheetAll"];

                Store.dispatch("getUserPermissions").then(() => {
                    const userPermissions = Store.state.userPermissions;
                    const isAvailablePage = userPermissions.some((permission) => permissions.includes(permission));
                    if (isAvailablePage) {
                        const { id } = to.params;
                        Store.dispatch("timesheets/getData", { id }).then((res) => {
                            if (res.id.toString() === id.toString()) {
                                next();
                            } else {
                                next({ name: "error-404" });
                            }
                        });
                    } else {
                        next({ name: "error-403" });
                    }
                });
            } else {
                window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
            }
        },
    },

    {
        path: "/timesheets/print/:id",
        name: "print-timesheet",
        component: TimesheetChartPrint,
        meta: {
            title: "Табели учёта рабочего времени",
            print: true,
        },

        beforeEnter: (to, from, next) => {
            next();
        },
    },
];
